/**
 * Bird init helper
 * Pollaa, kunnes BirdPickupDelivery on ladattu
 */
function initBird() {
  if (window.BirdPickupDelivery && BirdPickupDelivery.init) {
    BirdPickupDelivery.init();
  } else {
    setTimeout(initBird, 200);
  }
}

/**
 * Drawer & cart events
 */
document.addEventListener('cart-drawer:open', () => setTimeout(initBird, 300));
document.addEventListener('cart:updated', initBird);
document.addEventListener('cart:refresh', initBird);
document.addEventListener('shopify:section:load', initBird);
document.addEventListener('DOMContentLoaded', initBird);

/**
 * LazyScriptLoader-modifikaatio Birdille
 */
class LazyScriptLoaderWithBird {
  constructor() {
    this.scripts = [];
    this.selector = 'script[data-loading="lazy"][data-src]';
    this.interactionEvents = ['mouseover','keydown','touchmove','touchstart','click'];
    this.loadAfterMsIfNoInteraction = 5000;
    this.loadTimer = null;

    this.boundStartLoading = this.startLoadingScripts.bind(this);
  }

  init() {
    this.scripts = document.querySelectorAll(this.selector);
    if (!this.scripts.length) return;

    this.interactionEvents.forEach(event => {
      document.addEventListener(event, this.boundStartLoading, { passive: true });
    });

    this.loadTimer = setTimeout(this.boundStartLoading, this.loadAfterMsIfNoInteraction);
  }

  startLoadingScripts() {
    clearTimeout(this.loadTimer);
    this.loadScripts();

    this.interactionEvents.forEach(event => {
      document.removeEventListener(event, this.boundStartLoading);
    });
  }

  loadScripts() {
    this.scripts.forEach(script => {
      if (script.dataset.loading === 'loaded') return;
      this.loadScript(script);
    });
  }

  loadScript(script) {
    script.dataset.loading = 'loaded';
    script.src = script.dataset.src;
    script.removeAttribute('data-src');
    console.log('loaded script', script.src);

    // Jos skripti on Bird, initioi heti
    if (script.src.includes('bird')) {
      initBird();
    }
  }
}

// Käynnistä lazy loader
window.addEventListener('load', () => {
  const loader = new LazyScriptLoaderWithBird();
  loader.init();
});
